document.addEventListener('click', event => {
    const target = event.target.closest('[data-ga]');
    if (!target) return;
    const gaType = target.dataset.ga;
    const clickEvent = {
        'event_category': gaType || 'body',
        'event_page': window.location.pathname,
        'event_label': target.dataset.label || (target.innerText + '').trim()
            || target.getAttribute('alt') || ''
    };
    switch (gaType) {
        // header
        case 'header_download_prodlist':
            clickEvent.event_area = 'header_products';
            clickEvent.event_label = 'Download the product list';
            break;
        // blockchain
        case 'blockchain_go_to_fund':
            clickEvent.event_area = 'blockchain';
            clickEvent.event_label = 'Go to Fund Page for more ETF info Blockchain';
            break;
        case 'blockchain_go_to_sales':
            clickEvent.event_area = 'blockchain';
            clickEvent.event_label = 'Get in touch with Sales Blockchain';
            break;
    }

    gtag('event', 'click', clickEvent);
    sendEvent('click', clickEvent);
});

document.addEventListener('submit', event => {
    const target = event.target.closest('[data-ga]');
    if (!target) return;
    const gaType = target.dataset.ga;
    const submitEvent = {
        'event_category': gaType || 'body',
        'event_page': window.location.pathname,
        'event_label': target.dataset.label || target.name || ''
    };
    switch (gaType) {
        case 'subscribe_to_blog':
            submitEvent.event_area = 'footer_subscribe';
            submitEvent.event_label = 'Subscribe to blog';
            break;
    }

    gtag('event', 'submit', submitEvent);
    sendEvent('click', clickEvent);
});

function sendEvent(action, data) {
    $.post('/stats.php', {
        c: data.event_category,
        l: data.event_label,
        a: action,
        g: $.cookie('_ga'),
    });
}

function gtag() {
    dataLayer.push(arguments);
}

//Ptarmigan
gtag('config', 'DC-11386696');

document.addEventListener('DOMContentLoaded', function () {
    gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'u7': window.location.href,
        'send_to': 'DC-11386696/bitwi00/bitwi0+standard'
    });
})

window.addEventListener('scroll', function PTscroll() {
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollThreshold = documentHeight * 0.75;

    if (window.scrollY + windowHeight >= scrollThreshold) {
        gtag('event', 'conversion', {
            'allow_custom_scripts': true,
            'u7': window.location.href,
            'send_to': 'DC-11386696/bitwi00/bitwi001+standard'
        });
        window.removeEventListener('scroll', PTscroll);
    }
}, { passive: true })

document.addEventListener('click', e => {
    if (e.target.matches('[data-buy-now-broker-link]')) {
        gtag('event', 'conversion', {
            'allow_custom_scripts': true,
            'send_to': 'DC-11386696/bitwi00/bitwi000+standard'
        });
    }
    if (e.target.matches('[data-ga-downloadable]')) {
        gtag('event', 'conversion', {
            'allow_custom_scripts': true,
            'u7': window.location.href,
            'u9': e.target.innerText,
            'send_to': 'DC-11386696/bitwi00/bitwi00+standard'
        });
    }
})

document.addEventListener('submit', e => {
    if (e.target.matches('#sib-form')) {
        gtag('event', 'conversion', {
            'allow_custom_scripts': true,
            'send_to': 'DC-11386696/bitwi00/bitwi002+standard'
        });
    }
})